import  { useEffect, useState, useRef } from "react";
import { getFacultyUsers, confirmDeleteFacultyUser } from "../../services/authService";
import { getCookie } from "../../utils/cookieUtil";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const LoadingSpinner = () => (
  <div className="fixed inset-0 flex h-full items-center justify-center  bg-opacity-50 z-50">
    <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
  </div>
);



function FacultyUsers({ counter, searchMailQuery, selectedIds, setSelectedIds, selectedGroup, onExportRef, reload }) {
  const [facultyUsers, setFacultyUsers] = useState([]);
  const [loading, setDataLoading] = useState(false);

  const [permission, setPermission] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const itemsPerPage = 10;
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
    fetchFacultyUsers();
    const roles = getCookie("roleId");
    if (roles) setPermission(roles);
  }, []);

  useEffect(() => {
    fetchFacultyUsers();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchMailQuery]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedGroup]);

  useEffect(() => {
    fetchFacultyUsers({ search: searchMailQuery, group: selectedGroup });
  }, [counter, searchMailQuery, selectedGroup, reload]);


 useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);



  const fetchFacultyUsers = async () => {
    setDataLoading(true);
    try {
      const res = await getFacultyUsers();
      const data = await res.json();
      setFacultyUsers(data.users || []);
    } catch (error) {
      console.error("Error fetching faculty users:", error);
    } finally {
      setDataLoading(false);
    }
  };




  const filteredFacultyUsers = facultyUsers.filter((user) => {
    const emailMatch = user?.email?.toLowerCase().includes(searchMailQuery.toLowerCase());
    const groupMatch = selectedGroup && selectedGroup !== "All Groups"
      ? user?.group?.toLowerCase().includes(selectedGroup.toLowerCase())
      : true;
    return emailMatch && groupMatch;
  });

  const totalPages = Math.ceil(filteredFacultyUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredFacultyUsers.slice(startIndex, startIndex + itemsPerPage);


  useEffect(() => {
    if (onExportRef) {
      onExportRef.current = handleShare;
    }
  }, [onExportRef, currentUsers, permission]);


  const toggleDropdown = (userId) => {
    setActiveDropdown((prev) => (prev === userId ? null : userId));
  };

  const handleDeleteClick = (userId) => {
    setUserToDelete(userId);
    setShowConfirmationModal(true);
  };


  // const handleViewClick = (userId) => {
  //   navigate(`/app/userdetails?uid=${userId}`);
  // };


  const confirmDelete = async () => {
    try {
      await confirmDeleteFacultyUser(userToDelete);
      setShowConfirmationModal(false);
      setUserToDelete(null);
      fetchFacultyUsers();
    } catch (error) {
      console.error('[ERROR] Failed to complete deletion process:', error);
    }
  };

  const cancelDelete = () => {
    setShowConfirmationModal(false);
    setUserToDelete(null);
  };

  const handleCheckboxChange = (userId) => {
    setSelectedIds((prev) => {
      const faculty = prev?.faculty ?? [];
      const alreadySelected = faculty.includes(userId);

      return {
        ...prev,
        faculty: alreadySelected
          ? faculty.filter((e) => e !== userId)
          : [...faculty, userId],
      };
    });
  };




  const handleSelectAll = () => {
    const visibleIds = filteredFacultyUsers.map((user) => user.userId);

    setSelectedIds((prev) => {
      const faculty = prev?.faculty ?? [];
      const allSelected = visibleIds.every((userId) => faculty.includes(userId));

      return {
        ...prev,
        faculty: allSelected
          ? faculty.filter((userId) => !visibleIds.includes(userId))
          : [...new Set([...faculty, ...visibleIds])],
      };
    });
  };

    const handleShare = () => {
    const dataToExport = currentUsers.map((user) => {
      const row = { Role: user.role };

      if (permission.includes("adduser")) {
        row["First Name"] = user.firstName;
        row["Last Name"] = user.lastName;
        row["Email"] = user.email;
      }

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Faculty Users");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "faculty_users.xlsx");
  };

 return (
    <div className="flex-1 relative overflow-visible px-4 py-4" ref={dropdownRef}>
      <div className="mb-4 flex justify-between items-center">

      </div>

      <div className="relative w-full overflow-visible">
        <table className="w-full table-fixed text-sm text-left text-gray-900">
          <thead className="text-xs bg-gray-200 uppercase">
            <tr className="h-11 text-xs" >
              <th className="w-8 p-2">
                {/* <input type="checkbox" className="w-4 h-4 rounded text-blue-600" /> */}
                <input
                  type="checkbox"
                  checked={
                    filteredFacultyUsers.length > 0 &&
                    filteredFacultyUsers.every((u) => (selectedIds.faculty ?? []).includes(u.userId))
                  }
                  onChange={handleSelectAll}

                className="w-4 h-4" style={{ accentColor: '#900028' }} />


              </th>
              {permission.includes("adduser") && (
                <>
                  <th className="w-24 px-2 py-2">FIRST NAME</th>
                  <th className="w-24 px-2 py-2">LAST NAME</th>
                  <th className="w-24 px-2 py-2 truncate">EMAIL</th>
                </>
              )}
              <th className="w-10 px-2 py-2">ROLE</th>
              <th className="w-20 px-2 py-2 text-center">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((user) => {
              const dropdownKey = user.userId
              return (
                <tr key={dropdownKey} className="border-b hover:bg-gray-50  text-xs h-5">
                  <td className="p-2">
                    {/* <input type="checkbox" className="w-4 h-4 rounded text-blue-600" /> */}

                    <input
                      type="checkbox"
                      checked={(selectedIds.faculty ?? []).includes(user.userId)}
                      onChange={() => handleCheckboxChange(user.userId)}
                    className="w-4 h-4" style={{ accentColor: '#900028' }}/>

                  </td>
                  {permission.includes("adduser") && (
                    <>
                      <td className="px-2 py-1 truncate">  {user.firstName?.charAt(0).toUpperCase() + user.firstName?.slice(1)}</td>
                      <td className="px-2 py-1 truncate">{user.lastName?.charAt(0).toUpperCase() + user.lastName?.slice(1)}</td>
                      <td className="px-2 py-1 truncate">{user.email}</td>
                    </>
                  )}
                  <td className="px-2 py-1 truncate">{user.role}</td>
                  <td className="px-2 py-1 text-center relative"  >
                    <div className="inline-block text-left"  >
                      <button
                        className="text-gray-600 hover:bg-gray-200 p-1 rounded"
                        onClick={() => toggleDropdown(dropdownKey)}
                      >
                        &#x22EE;
                      </button>
                      {activeDropdown === dropdownKey && (
                        <div className="absolute right-0 z-50 mt-2 w-24 bg-white border rounded shadow-lg ">
                          {/* <button
                            className="block w-full px-4 py-2 text-sm text-black hover:bg-gray-100"
                            onClick={() => handleViewClick(user.uid)}
                            disabled={!user.uid}
                          >
                            View
                          </button> */}
                          <button
                            className="block w-full px-4 py-2 text-sm text-black hover:bg-gray-100"
                            onClick={() => handleDeleteClick(dropdownKey)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center mt-4 gap-1">
        {(() => {
          const maxVisible = 6;
          let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
          let end = start + maxVisible - 1;
          if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - maxVisible + 1);
          }

          const pages = [];
          for (let i = start; i <= end; i++) {
            pages.push(
              <button
                key={i}
                onClick={() => setCurrentPage(i)}
                className={`px-3 py-1 text-sm rounded ${currentPage === i ? "font-bold text-black" : "text-gray-700 hover:bg-gray-200"}`}
              >
                {i}
              </button>
            );
          }
          return pages;
        })()}
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 flex items-center ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : "hover:bg-gray-100"}`}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 transition-all duration-300 ease-in-out animate-fade-in">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Confirm Deletion</h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to permanently delete this user?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={cancelDelete}
                className="px-5 py-2 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition duration-200"
              >
                Cancel
              </button>
              <button
                onClick={() => confirmDelete(userToDelete)}
                className="px-5 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition duration-200"
              >
                Yes, Delete
                {loading && <LoadingSpinner />}
              </button>
            </div>
          </div>
        </div>
      )}
  {loading && <LoadingSpinner />}
    </div>
  );

}

export default FacultyUsers;